<template>
  <div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-for="(item, i) in dataList" :key="i" :item="item">
          <div
            :class="
              'drawal-item van-hairline--bottom ' +
                (item.TransactionOrder.LX_TransactionStatus == 1
                  ? 'wait'
                  : 'failed')
            "
          >
            <div class="th" v-if="item.BankTypeId == 1">
              <img src="~@/assets/images/card-bank.png" alt="" class="thumb" />
            </div>
            <div class="th" v-else>
              <img
                src="~@/assets/images/card-zhifubao.png"
                alt=""
                class="thumb"
              />
            </div>
            <div class="bd">
              <div class="thead">
                <div class="name">
                  {{ item.BankTypeId == 1 ? "银行卡" : "支付宝" }}
                </div>
                <div class="status">
                  {{
                    getApproveStatusApplyText(
                      item.TransactionOrder.LX_TransactionStatus
                    )
                  }}
                </div>
              </div>
              <div v-if="item.BankTypeId == 1">{{ item.CollectionNumber }}</div>
              <div v-else>{{ item.AlipayAccount }}</div>
              <div class="date">{{ item.TransactionOrder.AddDatetime }}</div>
            </div>
            <div class="ft">-{{ item.TransactionOrder.PayableCoinCount }}</div>
          </div>
          <!--         
        <div class="drawal-item van-hairline--bottom wait">
          <div class="th">
            <img src="~@/assets/image/card-bank.png" alt="" class="thumb" />
          </div>
          <div class="bd">
            <div class="thead">
              <div class="name">银行卡</div>
              <div class="status">已完成</div>
            </div>
            <div class="date">2020-12-02 16:35</div>
          </div>
          <div class="ft">16800</div>
        </div>
        <div class="drawal-item van-hairline--bottom failed">
          <div class="th">
            <img src="~@/assets/image/card-bank.png" alt="" class="thumb" />
          </div>
          <div class="bd">
            <div class="thead">
              <div class="name">支付宝</div>
              <div class="status">已完成</div>
            </div>
            <div class="date">2020-12-02 16:35</div>
          </div>
          <div class="ft">-16800</div>
        </div> -->
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import common from "../tools/common";

export default {
  data() {
    return {
      options: {
        type: "TransactionDetailApplyList",
        PageIndex: 1,
        approveStatus: this.asId,
      },
      offset: 100,
      refreshing: false,
      loading: true,
      finished: false,
      dataList: [],
    };
  },
  props: {
    asId: Number,
  },
  computed: {
    getApproveStatusApplyText() {
      return function(val) {
        return common.Text.getApproveStatusApplyText(val);
      };
    },
  },
  methods: {
    init() {
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      Object.assign(this.options, {
        PageIndex: 1,
      });
      this.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        PageIndex: this.options.PageIndex + 1,
      });
      this.loading = true;
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          common.Response.callNotMsgResponse(res, function(result) {
            console.log(result)
            if (result.data.length <= 0) {
              that.finished = true;
            }
            if (that.options.PageIndex > 1) {
              if (result.data.length > 0) {
                result.data.forEach((element) => {
                  that.dataList.push(element);
                });
              }
            } else {
              that.dataList = result.data;
            }
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
.drawal-item {
  display: flex;
  align-items: center;
  padding: 15px;
  .th {
    margin-right: 15px;
    .thumb {
      width: 30px;
      height: 30px;
      object-fit: contain;
    }
  }
  .bd {
    flex: 1;
    overflow: hidden;
    .thead {
      overflow: hidden;
      display: flex;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .name {
        font-size: 16px;
        color: #414141;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .status {
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .date {
      font-size: 12px;
      color: #a1a1a1;
      margin-top: 4px;
    }
  }
  .ft {
    margin-left: 15px;
    font-size: 21px;
  }
  &.success {
    .status {
      color: #aeaeae;
    }
    .ft {
      color: #414141;
    }
  }
  &.wait {
    .status,
    .ft {
      color: green;
    }
  }
  &.failed {
    .status,
    .ft {
      color: red;
    }
  }
}
</style>
